<mat-card>
    <h1 class="subtitle col-md-12">{{texteService.getTexte('TITLE_RENDEZ_VOUS')}}</h1>
    <mat-card-content class="col-md-12">
        <form [formGroup]="rendezvousForm">
            <div class="form-row d-flex align-self-center">
                <span id="rendezvous-specialite-label" class="col-md-5 align-self-center form-label">{{texteService.getTexte('LABEL_SPECIALITE')}}</span>
                <mat-form-field class="col-md-7">
                    <mat-select formControlName="specialite" (selectionChange)="onSpecialiteChanged($event)" aria-labelledby="rendezvous-specialite-label">
                        <mat-option *ngFor="let specialite of specialites" [value]="specialite">
                            {{texteService.getTexte(specialite.codeTexte, specialite.libelle)}}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="rendezvousForm.controls.specialite.touched && rendezvousForm.controls.specialite.hasError('required')">
                        {{texteService.getTexte('ERR_CHAMP_REQUIRED')}}</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row d-flex align-self-center" *ngIf="pathologies.length > 0">
                <span id="rendezvous-pathologie-label" class="col-md-5 align-self-center form-label">{{texteService.getTexte('LABEL_PATHOLOGIE')}}</span>
                <mat-form-field class="col-md-7">
                    <mat-select formControlName="pathologie" aria-labelledby="rendezvous-pathologie-label">
                        <mat-option *ngFor="let pathologie of pathologies" [value]="pathologie">
                            {{texteService.getTexte(pathologie.codeTexte, pathologie.libelle)}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="form-row d-flex align-self-center">
                <span id="rendezvous-demande-label"
                    class="col-md-5 align-self-center form-label">{{texteService.getTexte('LABEL_RENDEZ_VOUS_DEMANDE_1')}}</span>
                <mat-form-field class="col-md-3">
                    <mat-select formControlName="demande" aria-labelledby="rendezvous-demande-label">
                        <mat-option *ngFor="let demande of demandes" [value]="demande">
                            {{texteService.getTexte(demande.codeTexte, demande.libelle)}}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="rendezvousForm.controls.demande.touched && rendezvousForm.controls.demande.hasError('required')">
                        {{texteService.getTexte('ERR_CHAMP_REQUIRED')}}</mat-error>
                </mat-form-field>
                <span class="col-md align-self-center form-label">{{texteService.getTexte('LABEL_RENDEZ_VOUS_DEMANDE_2')}}</span>
            </div>

            <div class="form-row d-flex align-self-center">
                <label for="rendezvous-date"
                    class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_RENDEZ_VOUS_DATE')}}<span
                        class="red-label">*</span></label>
                <mat-form-field class="input-form col-md-7">
                    <input id="rendezvous-date" readonly (click)="dateRendezvousPicker.open()" matInput [matDatepicker]="dateRendezvousPicker" formControlName="dateRendezvous">
                    <mat-datepicker-toggle matSuffix [for]="dateRendezvousPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dateRendezvousPicker></mat-datepicker>
                    <mat-error
                        *ngIf="rendezvousForm.controls.dateRendezvous.touched && rendezvousForm.controls.dateRendezvous.hasError('required')">
                        {{texteService.getTexte('ERR_RENDEZ_VOUS_DATE')}}</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row d-flex align-self-center">
                <label for="rendezvous-heure"
                    class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_RENDEZ_VOUS_HEURE')}}<span
                        class="red-label">*</span></label>
                <mat-form-field class="input-form col-md-7">
                    <input id="rendezvous-heure" matInput type="time" name="heure" formControlName="heure" />
                    <mat-error
                        *ngIf="rendezvousForm.controls.heure.touched && rendezvousForm.controls.heure.hasError('required')">
                        {{texteService.getTexte('ERR_RENDEZ_VOUS_HEURE')}}</mat-error>
                </mat-form-field>
            </div>
        </form>
    </mat-card-content>
</mat-card>
